/**
 * @generated SignedSource<<3f5a72379d3931388c3d73789ae3a053>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPageTools_sheet$data = {
  readonly id: string;
  readonly note_combine_steps: ReadonlyArray<{
    readonly id: string;
    readonly status: MusicParseStatus;
    readonly data: {
      readonly notes?: ReadonlyArray<{
        readonly note_id: string;
        readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlayNote_Note">;
      }>;
    } | null;
  }>;
  readonly note_finder_user_confirmation_steps: ReadonlyArray<{
    readonly id: string;
    readonly status: MusicParseStatus;
  }>;
  readonly " $fragmentType": "NoteFinderPageTools_sheet";
};
export type NoteFinderPageTools_sheet$key = {
  readonly " $data"?: NoteFinderPageTools_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageTools_sheet">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPageTools_sheet",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "note_combine_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "NOTE_DATA_SOURCE_COMBINE"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MusicParseStepDataNoteDataSourceCombineNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "note_id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NoteFinderPageOverlayNote_Note"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "MusicParseStepDataNoteDataSourceCombine",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "steps(step_type:\"NOTE_DATA_SOURCE_COMBINE\")"
    },
    {
      "alias": "note_finder_user_confirmation_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "NOTE_USER_CONFIRMATION"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": "steps(step_type:\"NOTE_USER_CONFIRMATION\")"
    }
  ],
  "type": "MusicSheet",
  "abstractKey": null
};
})();

(node as any).hash = "8683f9d088eaa3943456fe94589346a7";

export default node;
